// extracted by mini-css-extract-plugin
module.exports = {"root":"changePassword_root__1N6jv","size_50":"changePassword_size_50__3XYD7","button":"changePassword_button__1zyQS"};